<template>
  <el-card shadow="never" class="reporting-content">
    <el-row :gutter="20">
      <el-col :span="8" :offset="0">
        <img :src="form.logoUrl" height="66px" alt="">
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <ul>
          <li><span class="text">Country:</span><span class="value">{{ address.countryName }}</span></li>
          <li><span class="text">City:</span><span class="value">{{ address.cityName }}</span></li>
          <li><span class="text">Timezone:</span><span class="value">{{ form.timezoneName }}</span></li>
          <li><span class="text">Type of Organisation:</span><span class="value">{{ form.typeOfOrganizationName }}</span></li>
          <li><span class="text">Organisation Started On:</span><span class="value">{{ form.startedOn }}</span></li>
          <li><span class="text">Organisation Name:</span><span class="value">{{ form.name }}</span></li>
          <li><span class="text">Organisation Trading Name:</span><span class="value">{{ form.tradingName }}</span></li>
          <li><span class="text">No. of Organisation Members:</span><span class="value">{{ form.text }}</span></li>
          <li><span class="text">Main Phone No.:</span><span class="value">{{ form.primaryPhone }}</span></li>
          <li><span class="text">Main Fax No.:</span><span class="value">{{ form.fax }}</span></li>
          <li><span class="text">Main Email:</span><span class="value">{{ form.email }}</span></li>
          <li><span class="text">Main Website:</span><span class="value"><a v-if="form.website" :href="form.website" target="_blank">{{ form.website }}</a></span></li>
          <li><span class="text">eCommerce Site:</span><span class="value"><a v-if="form.eCommerceWebsite" :href="form.eCommerceWebsite" target="_blank">{{ form.eCommerceWebsite }}</a></span></li>
          <li><span class="text">LinkedIn Page:</span><span class="value"><a v-if="form.linkedinPage" :href="form.linkedinPage" target="_blank">{{ form.linkedinPage }}</a></span></li>
          <li><span class="text">Facebook Page:</span><span class="value"><a v-if="form.facebookPage" :href="form.facebookPage" target="_blank">{{ form.facebookPage }}</a></span></li>
          <li><span class="text">Twitter Account:</span><span class="value"><a v-if="form.twitterAccount" :href="form.twitterAccount" target="_blank">{{ form.twitterAccount }}</a></span></li>
          <li><span class="text">Youtube:</span><span class="value"><a v-if="form.youtube" :href="form.youtube" target="_blank">{{ form.youtube }}</a></span></li>
          <li><span class="text">Other Social:</span><span class="value"><a v-if="form.otherSocial" :href="form.otherSocial" target="_blank">{{ form.otherSocial }}</a></span></li>
        </ul>
      </el-col>
      <el-col :span="16">
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <div class="block-title">
              Main Address
            </div>
            <ul>
              <li><span class="text">Address Line 1:</span><span class="value">{{ mainAddress.address }}</span></li>
              <li><span class="text">Address Line 2:</span><span class="value">{{ mainAddress.address2 }}</span></li>
              <li><span class="text">Address Line 3:</span><span class="value">{{ mainAddress.address3 }}</span></li>
              <li><span class="text">Country:</span><span class="value">{{ mainAddress.mainCountryName }}</span></li>
              <li><span class="text">State / Province / Country:</span><span class="value">{{ mainAddress.mainStateName }}</span></li>
              <li><span class="text">City:</span><span class="value">{{ mainAddress.mainCityName }}</span></li>
              <li><span class="text">Post Code:</span><span class="value">{{ mainAddress.mainPostCode }}</span></li>
            </ul>
          </el-col>
          <el-col :span="12" :offset="0">
            <iframe width="100%" height="100%" id="gmap_canvas" :src="map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <div class="block-title">
              Postal Address
            </div>
            <ul>
              <li><span class="text">Address Line 1:</span><span class="value">{{ postalAddress.postalAddress }}</span></li>
              <li><span class="text">Address Line 2:</span><span class="value">{{ postalAddress.postalAddress2 }}</span></li>
              <li><span class="text">Address Line 3:</span><span class="value">{{ postalAddress.postalAddress3 }}</span></li>
              <li><span class="text">Country:</span><span class="value">{{ postalAddress.postalCountryName }}</span></li>
              <li><span class="text">State / Province / Country:</span><span class="value">{{ postalAddress.postalStateName }}</span></li>
              <li><span class="text">City:</span><span class="value">{{ postalAddress.postalCityName }}</span></li>
              <li><span class="text">Post Code:</span><span class="value">{{ postalAddress.postalPostCode }}</span></li>
            </ul>
          </el-col>
          <el-col :span="12" :offset="0">
            <iframe width="100%" height="100%" id="gmap_canvas" :src="map2" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import axios from "axios"
import moment from 'moment'

export default {
  name: "TaxationContent",
  components: {},
  data() {
    return {
      moment: moment,
      map: '',
      map2: '',
      currencyList: [],
      timezoneList: [],

      form: {
        logoUrl: null,
        text: '',

        timezoneName: null,
        countryId: null,
        typeOfOrganisationId: null,
        typeOfOrganizationName: null,
        currencyId: null,
        startedOn: null,
        name: null,
        tradingName: null,
        primaryPhone: null,
        fax: null,
        email: null,
        website: null,
        eCommerceWebsite: null,
        linkedinPage: null,
        facebookPage: null,
        twitterAccount: null,
        youtube: null,
        otherSocial: null,
      },

      address: {
        countryName: null,
        stateName: null,
        cityName: null,
      },
      mainAddress: {
        mainCountryName: null,
        mainStateName: null,
        mainCityName: null,
        mainPostCode: '',
        address: null,
        address2: null,
        address3: null,
      },
      postalAddress: {
        postalCountryName: null,
        postalStateName: null,
        postalCityName: null,
        postalPostCode: '',
        postalAddress: null,
        postalAddress2: null,
        postalAddress3: null,
      }
    }
  },
  computed: {
    currencyName() {
      const item = this.currencyList.find(val => val.id === this.form.currencyId)
      return item ? item.name : null
    },
  },
  async mounted() {
    await this.getTimeZones()
    await this.directories()
    await this.item()
    await this.getTypeOfOrganizationName(this.form.countryId)
  },
  methods: {
    async getTimeZones() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.post('/api/v1/users/directories?operation=updateMe')
      this.timezoneList = data.timezoneList ? data.timezoneList : []
      loader.hide()
    },
    async directories(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=update`)
      this.currencyList = data.currencyList
      loader.hide()
    },
    async item(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.post(`/api/v1/companies/item?companyId=${this.$route.query.companyId}`)
      if (data.item) {
        this.form.logoUrl = data.item.additionalInfo ? data.item.additionalInfo.avatarUrl : ''

        this.form.name = data.item.name
        this.form.email = data.item.email
        this.form.currencyId = data.item.currencyId
        this.form.countryId = data.item.countryId
        this.form.typeOfOrganisationId = data.item.typeOfOrganisationId

        let customFieldsJson = JSON.parse(data.item.customFieldsJson)

        this.form.tradingName = customFieldsJson.tradingName
        this.form.startedOn = customFieldsJson.startedOn ? moment(customFieldsJson.startedOn, 'DD/MM/YYYY').format('DD MMM YYYY') : null
        this.form.primaryPhone = customFieldsJson.primaryPhone
        this.form.fax = customFieldsJson.fax
        this.form.website = customFieldsJson.website
        this.form.eCommerceWebsite = customFieldsJson.eCommerceWebsite
        this.form.linkedinPage = customFieldsJson.linkedinPage
        this.form.facebookPage = customFieldsJson.facebookPage
        this.form.twitterAccount = customFieldsJson.twitterAccount
        this.form.youtube = customFieldsJson.youtube
        this.form.otherSocial = customFieldsJson.otherSocial
        const timeZone = this.timezoneList.find(item => item.id === customFieldsJson.timezoneId)
        this.form.timezoneName = timeZone ? timeZone.name : null

        this.address.countryName = data.item.country.name
        this.address.stateName = data.item.state.name
        this.address.cityName = data.item.city.name

        this.mainAddress.mainCountryName = data.item.mainCountry ? data.item.mainCountry.name : null
        this.mainAddress.mainStateName = data.item.mainState ? data.item.mainState.name : null
        this.mainAddress.mainCityName = data.item.mainCity ? data.item.mainCity.name : null
        this.mainAddress.address = data.item.address
        this.mainAddress.address2 = data.item.address2
        this.mainAddress.address3 = data.item.address3
        this.mainAddress.mainPostCode = customFieldsJson.mainPostCode

        this.postalAddress.postalCountryName = data.item.postalCountry ? data.item.postalCountry.name : null
        this.postalAddress.postalStateName = data.item.postalState ? data.item.postalState.name : null
        this.postalAddress.postalCityName = data.item.postalCity ? data.item.postalCity.name : null
        this.postalAddress.postalAddress = customFieldsJson.postalAddress
        this.postalAddress.postalAddress2 = customFieldsJson.postalAddress2
        this.postalAddress.postalAddress3 = customFieldsJson.postalAddress3
        this.postalAddress.postalPostCode = customFieldsJson.postalPostCode

        this.map = `https://maps.google.com/maps?q=${this.mainAddress.mainCountryName},${this.mainAddress.mainStateName},${this.mainAddress.mainCityName},${this.mainAddress.address},${this.mainAddress.address2},${this.mainAddress.address3}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        this.map2 = `https://maps.google.com/maps?q=${this.postalAddress.postalCountryName},${this.postalAddress.postalStateName},${this.postalAddress.postalCityName},${this.postalAddress.postalAddress},${this.postalAddress.postalAddress2},${this.postalAddress.postalAddress3}&t=&z=13&ie=UTF8&iwloc=&output=embed`
      }
      loader.hide()
    },
    async getTypeOfOrganizationName(countryId) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.get(`/api/v1/type-of-organisation/list?countryId=${countryId}`)
      if (this.form.typeOfOrganisationId) this.form.typeOfOrganizationName = data.list.find(item => item.id === this.form.typeOfOrganisationId).name
    },
  }
}
</script>

<style lang="scss" scoped>
.reporting-content {
  ul {
    margin-top: 20px;
    list-style: none;
    padding-left: 0;
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 10px 0;
      &:first-child {
        margin-top: 0;
      }
      .text {
        font-size: 18px;
        color: grey;
      }
      .value {
        margin-left: 10px;
      }
    }
  }
  .block-title {
    font-size: 18px;
    font-weight: bold;
  }
}

.used {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
